import { JavaAPI, JAVA_SERVICE_ENDPOINTS } from '@buildwise/libs/services';
import { ConfigType } from 'config/config';

export type ConfigResponseType = { config?: ConfigType; configs?: ConfigType[] };

class TasksAPI extends JavaAPI {
  public getMyTasks({ companyId }: { companyId: string }) {
    return this.get(JAVA_SERVICE_ENDPOINTS.GET_MY_TASKS.replace(':companyId', companyId));
  }
}

const tasksAPI = new TasksAPI();
export default tasksAPI;
